var map = {
	".": 16,
	"./": 16,
	"./artoimage.jpg": 229,
	"./aziahimage.jpg": 230,
	"./becelogo.png": 231,
	"./bethimage.jpg": 232,
	"./bonlinelogo.png": 233,
	"./cambridge2.png": 234,
	"./cambridge3.png": 235,
	"./cambridge4.png": 236,
	"./chanderimage.jpg": 237,
	"./eileenimage.png": 238,
	"./freelancers.png": 239,
	"./index": 16,
	"./index.js": 16,
	"./mylesimage.png": 240,
	"./noimage.png": 241,
	"./one.png": 242,
	"./professional.png": 243,
	"./profile.jpg": 244,
	"./profile.png": 245,
	"./school.png": 246,
	"./testimonial-hi1.jpg": 247,
	"./testimonial_2.jpg": 248,
	"./testimonial_4.jpg": 249,
	"./testimonial_5.jpg": 250,
	"./two.png": 251,
	"./world.png": 252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 228;